<template>
<div id="page-templates" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Actualizar PDF Terminos y Condiciones" class="elevation-1 px-5 py-3" >

                    <v-card-text>
                        
                            <v-card-text>
                                <v-form ref="form" lazy-validation>
                                    <v-container grid-list-md>
                                        <v-layout wrap>

                                            <v-flex xs12>
                                                <v-text-field label="PDF Español" @click='pickFile("a1")' v-model='file_a_1' :readonly="true" prepend-icon='attach_file'></v-text-field>
                                                <input type="file" style="display: none" ref="a1" accept=".pdf" @change="onFilePicked" >
                                                <!-- Terminos.pdf -->
                                                 <v-btn  dark x-small color="orange" @click.native="downloadURL('Terminos.pdf');" title="Descargar" v-tippy>
                                                    <v-icon dark>search</v-icon>Descargar PDF
                                                </v-btn>
                                            </v-flex>
                                         <v-divider></v-divider>
                                         <p/> <p/>
                                            <v-flex xs12>
                                                <v-text-field label="PDF Ingles" @click='pickFile("a2")' v-model='file_a_2' :readonly="true" prepend-icon='attach_file'></v-text-field>
                                                <input type="file" style="display: none" ref="a2" accept=".pdf" @change="onFilePicked" >
                                                  <v-btn  dark x-small color="orange" @click.native="downloadURL('Terminos_English.pdf');" title="Descargar" v-tippy>
                                                    <v-icon dark>search</v-icon>Descargar PDF
                                                </v-btn>
                                                <!-- Terminos_English.pdf -->
                                                
                                            </v-flex>
                                             
                                        </v-layout>
                                    </v-container>
                                </v-form>
                            </v-card-text>
                       
                        
                    </v-card-text>
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import axios from "axios";

export default {
    created: function () {

    },
    data() {
        return {
            fab: false,

            file_a_1: "",
            file_a_2: "",
           

            show_loading: true,

            breadcrumbs: [{
                    text: "Administración",
                    disabled: false,
                    to: "/admin"
                },
                {
                    text: "PDF Terminos y Condiciones",
                    disabled: true,
                    href: ""
                }
            ],
            selected: "",
            title: "",
            modal: false,
            update: false,
            estados: [],
            size_file: 0,
            type_file: 'application/pdf',
            rules: {
                required: v => !!v || "Este campo es requerido",
            },

        };
    },

    methods: {
        pickFile(id) {
            if (id == 'a1'){
                this.selected='Terminos.pdf'; 
                this.$refs.a1.click();
            } 
            if (id == 'a2') {
                this.selected='Terminos_English.pdf'; 
                this.$refs.a2.click();
            }
           
            
        },
        downloadURL: function (key) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: key,
                bucket: "descargas.econnectpro.mx"
            }
            axios.post(this.$hostname + 's3/download_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.target = "_blank";
                        a.click();
                        a.parentNode.removeChild(a);

                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        onFilePicked(e) {
            try {
                const files = e.target.files;
                if (files[0] !== undefined) {

                    this.name_file = files[0].name;
                    this.size_file = files[0].size;
                    this.type_file = files[0].type;

                    if (this.size_file > 1000 * 1000 * 10) {
                        this.$swal({
                            type: "warning",
                            title: "¡Operación no Permitida!",
                            text: "El archivo no debe ser mayor a 10MB.",
                        });
                        this.reset();
                        return false;
                    }
                   // console.log(this.selected);
                   this.uploadFile(files[0], this.selected);
                }
            } catch (error) {
                console.log(error);
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al leer el archivo. Favor de verificar que el archivo no esté dañado.",
                    footer: ""
                });
                this.$root.$dialogLoader.hide();
                this.reset();
            }

        },

        uploadFile: function (file, referencia) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

            var thisObj = this;

            var keyFile = referencia;

            var datos = {
                key: keyFile,
                bucket: "descargas.econnectpro.mx",
                type: thisObj.type_file
            }
            axios.post(thisObj.$hostname + 's3/upload_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var urlput = res.data.mensaje;
                        //console.log(urlput);
                        axios.put(urlput, file, {
                                headers: {
                                    'Content-Type': thisObj.type_file
                                }
                            })
                            .then((res) => {
                                thisObj.$root.$dialogLoader.hide();
                                thisObj.$swal({
                                    type: "success",
                                    title: "¡Operación Exitosa!",
                                    text: "El archivo se actualizó correctamente",
                                    footer: '',
                                });
                            })
                            .catch((error) => {
                                thisObj.$root.$dialogLoader.hide();
                                thisObj.$swal({
                                    type: "error",
                                    title: "¡Operación no Permitida!",
                                    text: "Ocurrió un erro al cargar el archivo. Intente nuevamente por favor.",
                                    footer: '',
                                });
                                console.log(error);
                            });

                    } else {
                        thisObj.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un erro al cargar el archivo. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al cargar el archivo. Intente nuevamente por favor.";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    thisObj.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                    thisObj.$root.$dialogLoader.hide();
                });

        },

    }
};
</script>
